import React, { useEffect, useRef, useState } from "react";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../../../Utilitie";
import axios from "axios";
import Loading from "../../../../Extra/Loading";
import MachineEngTable from "./MachineEngTable";
import NoDataFound from "../../../../Extra/NoDataFound";

const MachineEngClassic = () => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [fetchData, setFetchData] = useState([]);
  const tableRef = useRef();
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getBlockMachineTotalReport?start=${startDate}&end=${endDate}`
      );
      if (response.data.status === "ok") {
        setFetchData(response.data.daterange);
      } else {
        setFetchData([]);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchedData();
  }, []);

  return (
    <div>
      <div className="d-flex justify-content-between bg-dark text-white p-1 papaDiv">
        <h5 className="">Machine report </h5>
        <div>
          <div className="d-flex  align-items-center ">
            <b>From </b>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="me-1"
            />

            <b>To </b>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              // className="form-control"
            />
            <button
              className="ms-1 btn btn-sm btn-outline-light"
              onClick={fetchedData}
            >
              Fetch
            </button>
          </div>
        </div>
      </div>
      <div className="papaDiv position-relative">
        {loading && <Loading />}
        <MachineEngTable data={fetchData} />
        {!fetchData && <NoDataFound />}
      </div>
    </div>
  );
};
export default MachineEngClassic;
